import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_no_auth, http_auth} from "@utils"
import * as auth from "../Auth"
import {REFRESH_TOKEN} from "../../../utility/Utils"

export const getRegionsList = createAsyncThunk('soato/getRegionsList', async ({dispatch}) => {
    try {
        const response = await http_no_auth.get('/admin/v1/soato/regions')
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getSubRegionById = createAsyncThunk('soato/getSubRegionById', async () => {
    const response = await http_no_auth.get(`/admin/v1/soato/districts`)
    return response.data
})

export const getSubRegionsList = createAsyncThunk('soato/getSubRegionsList', async ({dispatch}) => {
    try {
        const response = await http_no_auth.get(`/admin/v1/soato/districts`)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getSubRegionsListByRegionId = createAsyncThunk('soato/getSubRegionListByRegionId', async (region_id) => {
    const response = await http_no_auth.get(`/admin/v1/soato/districts/${region_id}`)
    return response.data
})

export const getMaterialSubTypeList = createAsyncThunk('soato/getMaterialSubTypeList', async (data) => {
    const response = await http_no_auth.post(`/admin/v1/thing-sub-type/list`, data)
    return response.data
})

export const createMaterialSubType = createAsyncThunk('soato/createMaterialSubType', async (data, {rejectWithValue}) => {
    try {
        const response = await http_auth.post('/admin/v1/thing-sub-type/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getMaterialSubTypeListForReestr = createAsyncThunk('soato/getMaterialSubTypeListForReestr', async (data) => {
    const response = await http_no_auth.post(`/admin/v1/thing-sub-type/list`, data)
    return response.data
})

export const createCalendar = createAsyncThunk('soato/createCalendar', async (data, {rejectWithValue}) => {
    try {
        const response = await http_auth.post('/admin/v1/calendar-day/save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})


export const calendarList = createAsyncThunk('soato/calendarList', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post('/admin/v1/calendar-day/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})


export const soatoSlice = createSlice({
    name: 'soato',
    initialState: {
        regions: [],
        subRegion: [],
        subRegionByRegionId: [],
        subRegionById: [],
        materialSubType: [],
        materialSubTypeForReestr: [],
        calendarList: [],

        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [getRegionsList.fulfilled]: (state, actions) => {
            state.regions = actions.payload
        },
        [getSubRegionsListByRegionId.fulfilled]: (state, actions) => {
            state.subRegionByRegionId = actions.payload
        },
        [getSubRegionsList.fulfilled]: (state, actions) => {
            state.subRegion = actions.payload
        },
        [getSubRegionById.fulfilled]: (state, actions) => {
            state.subRegionById = actions.payload
        },
        [getMaterialSubTypeList.fulfilled]: (state, actions) => {
            state.materialSubType = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [getMaterialSubTypeList.pending]: (state) => {
            state.isLoading = true
        },
        [getMaterialSubTypeList.rejected]: (state) => {
            state.isLoading = false
        },

        [createMaterialSubType.fulfilled]: (state) => {
            state.isLoading_create = false
        },
        [createMaterialSubType.pending]: (state) => {
            state.isLoading_create = true
        },
        [createMaterialSubType.rejected]: (state) => {
            state.isLoading_create = false
        },

        [getMaterialSubTypeListForReestr.fulfilled]: (state, actions) => {
            state.materialSubTypeForReestr = actions.payload?.data
            state.isLoading = false
        },
        [getMaterialSubTypeListForReestr.pending]: (state) => {
            state.isLoading = true
        },
        [getMaterialSubTypeListForReestr.rejected]: (state) => {
            state.isLoading = false
        },

        [calendarList.fulfilled]: (state, actions) => {
            state.calendarList = actions.payload?.data
            state.current_page = actions.payload?.page
            state.count_item = actions.payload?.count
            state.total_count = actions.payload?.total_count
            state.isLoading = false
        },
        [calendarList.pending]: (state) => {
            state.isLoading = true
        },
        [calendarList.rejected]: (state) => {
            state.isLoading = false
        }
    }
})

export const {} = soatoSlice.actions
export default soatoSlice.reducer
